import memoize from 'fast-memoize'
import { css } from 'styled-components'
import { color } from 'utils'

import { ColorType } from './types'

const iconColor = (colorCode: ColorType, hoverColorCode?: ColorType) => css`
  fill: ${color(colorCode)};

  &:hover {
    fill: ${color(hoverColorCode ?? colorCode)};
  }
`

export default memoize(iconColor)
